var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.userData)?[_c('landing-page')]:_vm._e(),_c('listing-loader',{attrs:{"page":"looking_to_buy"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }